import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment, MenuItem, Box } from '@mui/material';
import { formatCurrency, parseCurrency } from '../utils/currencyUtils';
import * as API from '../api';

const CurrencyInput = ({ value, onChange, label, disabled }) => {
    const [localOriginal, setLocalOriginal] = useState('');
    const [localCurrency, setLocalCurrency] = useState('VND'); // Thêm state nội bộ để UI mượt mà
    const [isFocused, setIsFocused] = useState(false);
    const [systemRate, setSystemRate] = useState(25000);

    // Lấy tỷ giá từ hệ thống
    useEffect(() => {
        const fetchRate = async () => {
            try {
                const res = await API.getExchangeRate();
                if(res.data && res.data.rate) {
                    setSystemRate(parseFloat(res.data.rate));
                }
            } catch (e) { 
                console.warn("Using default rate"); 
            }
        };
        fetchRate();
    }, []);

    // Đồng bộ data từ ngoài vào (khi không focus để tránh giật con trỏ)
    useEffect(() => {
        if (value?.currency) {
            setLocalCurrency(value.currency);
        }
        if (!isFocused && value?.original !== undefined && value?.original !== null) {
            setLocalOriginal(formatCurrency(value.original, value?.currency || 'VND'));
        }
    }, [value?.original, value?.currency, isFocused]);

    const emitChange = (newOriginalStr, newCurrency, newRate) => {
        const numOriginal = parseCurrency(newOriginalStr, newCurrency);
        const numVnd = newCurrency === 'VND' ? numOriginal : numOriginal * newRate;

        onChange({
            original: numOriginal,
            currency: newCurrency,
            rate: newRate,
            vnd: numVnd
        });
    };

    // Khi đang gõ phím
    const handleAmountChange = (e) => {
        setLocalOriginal(e.target.value);
        emitChange(e.target.value, localCurrency, value?.rate || systemRate);
    };

    // Khi click ra ngoài ô nhập -> Format lại số cho đẹp
    const handleBlur = () => {
        setIsFocused(false);
        const parsed = parseCurrency(localOriginal, localCurrency);
        setLocalOriginal(formatCurrency(parsed, localCurrency));
    };

    // Khi chuyển đổi VND <-> USD
    const handleCurrencyChange = (e) => {
        const newCurrency = e.target.value;
        const currentVal = parseCurrency(localOriginal, localCurrency);
        
        let newVal = currentVal;

        // Tự động chia/nhân tỷ giá
        if (currentVal > 0) {
            if (localCurrency === 'VND' && newCurrency === 'USD') newVal = currentVal / systemRate;
            else if (localCurrency === 'USD' && newCurrency === 'VND') newVal = currentVal * systemRate;
        }

        const newStringVal = formatCurrency(newVal, newCurrency);
        
        // Bắt buộc cập nhật state nội bộ để UI thay đổi NGAY LẬP TỨC
        setLocalOriginal(newStringVal);
        setLocalCurrency(newCurrency);

        const newRate = newCurrency === 'USD' ? systemRate : 1;
        emitChange(newStringVal, newCurrency, newRate);
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                    label={label}
                    size="small"
                    fullWidth
                    disabled={disabled}
                    value={localOriginal}
                    onChange={handleAmountChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={handleBlur}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <TextField
                                    select
                                    variant="standard"
                                    value={localCurrency} // Bind trực tiếp vào state nội bộ
                                    onChange={handleCurrencyChange}
                                    disabled={disabled}
                                    InputProps={{ disableUnderline: true }}
                                    sx={{ 
                                        width: '60px',
                                        marginTop: '8px',
                                        '& .MuiSelect-select': { fontWeight: 'bold', color: '#007373' } 
                                    }}
                                >
                                    <MenuItem value="VND">VND</MenuItem>
                                    <MenuItem value="USD">USD</MenuItem>
                                </TextField>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        </Box>
    );
};

export default CurrencyInput;